<vwui-card class="mandating-info-card">
    <vwui-card-header>
        {{ 'COMPONENT.mandating.info_card.mandating_flow' | translate }}
    </vwui-card-header>
    <vwui-card-body>
        <ng-content></ng-content>
    </vwui-card-body>
</vwui-card>
